<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Arquivos</h5>
        <b-button
          title="Adicionar novo arquivo"
          size="sm"
          @click="adicionar()"
          class="mr-1 ml-2"
        >
          <i class="fe fe-plus"></i>
        </b-button>
      </div>
    </div>

    <file-list :outdateParent="outdateParent" class="mb-4" />

    <b-modal
      ref="adicionar"
      hide-footer
      title="Adicionar novo arquivo"
      size="xl"
    >
      <template v-slot:default="{ hide }">
        <form-item
          @hide="hide"
          @update="updateFile"
          :dispositivo="null"
        ></form-item>
      </template>
    </b-modal>

    <pending />

  </div>
</template>
<script>
import FileList from "./list-files";
import FormItem from "./form";
import Pending from "./pending";

export default {
  components: {
    FileList,
    FormItem,
    Pending
  },
  data: function () {
    return {
      outdateParent: false,
    };
  },
  methods: {
    updateFile(value) {
      this.outdateParent = value;
    },

    adicionar() {
      this.outdateParent = false;
      this.$refs["adicionar"].show();
    },
  },
  mounted() {},
};
</script>